import { render, staticRenderFns } from "./TranslationTool.vue?vue&type=template&id=550e1552&scoped=true"
import script from "./TranslationTool.vue?vue&type=script&lang=js"
export * from "./TranslationTool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550e1552",
  null
  
)

export default component.exports